import React, { useState, useEffect } from 'react'
import Slider from 'react-slick';

const BrandOne = () => {
    const [certifications, setCertifications] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchCertifications();
    }, []);
  const API_BASE_URL = process.env.REACT_APP_API_URL;

    const fetchCertifications = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/certifications/`, {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            let data = await response.json();
            console.log('Raw API response:', data);

            // Handle both direct array response and wrapped response
            if (Array.isArray(data)) {
                setCertifications(data);
            } else if (data.results && Array.isArray(data.results)) {
                // If paginated
                setCertifications(data.results);
            } else if (data.data && Array.isArray(data.data)) {
                // If wrapped in data object
                setCertifications(data.data);
            } else {
                console.error('Unexpected response format:', data);
                setCertifications([]);
            }
            
            setLoading(false);
        } catch (error) {
            console.error('Error fetching certifications:', error);
            setCertifications([]);
            setLoading(false);
        }
    };

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }

    function SamplePrevArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }

    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 1000,
        slidesToShow: 8,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            { breakpoint: 1599, settings: { slidesToShow: 7 } },
            { breakpoint: 1399, settings: { slidesToShow: 6 } },
            { breakpoint: 992, settings: { slidesToShow: 5 } },
            { breakpoint: 575, settings: { slidesToShow: 4 } },
            { breakpoint: 424, settings: { slidesToShow: 3 } },
            { breakpoint: 359, settings: { slidesToShow: 2 } },
        ],
    };

    if (loading) return <div>Loading certifications...</div>;

    return (
        <div className="brand py-80">
            <div className="container container-lg">
                <div className="brand-inner bg-color-one p-24 rounded-16">
                    <div className="section-heading">
                        <div className="flex-between flex-wrap gap-8">
                            <h5 className="mb-0">Our Certifications</h5>
                        </div>
                    </div>
                    <div className="brand-slider arrow-style-two">
                        <Slider {...settings}>
                            {certifications.map((cert) => (
                                <div key={cert.id} className="brand-item">
                                    <img src={cert.image} alt={`Certification ${cert.id}`} />
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrandOne;